import React, { FC, useEffect, useState } from "react";
import ButtonComponent from "../../../../shared/components/ButtonComponent";
import { SearchInput } from "../../../../shared/components/SearchInput";
import { PlusOutlined, RightOutlined, DownOutlined } from "@ant-design/icons";
import { Space, Table } from "antd";
import ToggleSwitch from "../../../../shared/components/ToggleSwitch";
import CardMenu from "../../../../shared/components/CourseComponents/CardMenu";
import InstituteBranchForm from "./InstituteBranchForm";
import "./instituteBranch.scss";
import { Branches } from "../../../../models/InstituteModel/branches.model";
import BranchService from "../../../../services/InstituteService/branch.service";
import PaginationComponent from "../../../../shared/components/PaginationComponent";
import DeleteAlert from "../../../../shared/components/DeleteAlert";
import { useLocation } from "react-router-dom";
import { Institutes } from "../../../../models/InstituteModel/institutes.model";
import { convertJSONToFormData } from "../../../../shared/utils/converJsonToFormData";
export const InstituteBranch: FC = (props: any) => {
  const { user } = props;
  const [showForm, setFormVisibility] = useState(false);
  const [currentBranch, setCurrentBranch] = useState<any>(null);
  const [branches, setBranches] = useState<Branches[]>([]);
  const [paginationMeta, setPaginationMeta] = useState<any>([]);
  const [currentPageNumber, setCurrentPageNumber] = useState<number>(1);
  const [deleteVisible, setDeleteVisibility] = useState(false);
  const [loading, setLoading] = useState<boolean>(true);
  const { state }: { state: Institutes } = useLocation();

  const fetchBranches = (params: any) => {
    setLoading(true);
    BranchService.fetchBranches(
      { ...params, institute_id: state?.id },
      (data, meta) => {
        setBranches(data);
        setPaginationMeta(meta);
        setLoading(false);
      },
      () => { },
      () => { }
    );
  };
  useEffect(() => {
    fetchBranches({ page: currentPageNumber });
  }, []);

  const handlePageChange = (page: number, pageSize: any) => {
    fetchBranches({ page: currentPageNumber });
    setCurrentPageNumber(page);
  };

  const handleSearch = (value: string) => {
    fetchBranches({ page: currentPageNumber, search: value });
  };

  const handleToggle = (id: any, value: boolean) => {
    let payload = { branch: { is_active: value } };
    const formData = convertJSONToFormData(payload);

    BranchService.updateBranch(
      id,
      formData,
      () => {
        fetchBranches({ page: currentPageNumber });
      },
      () => { },
      () => { }
    );
  };
  const handleDelete = () => {
    BranchService.deleteBranch(
      currentBranch?.id,
      () => {
        fetchBranches({ page: currentPageNumber });
        setDeleteVisibility(false);
      },
      () => { },
      () => { }
    );
  };

  return (
    <div className="institute-branch__container">
      <InstituteBranchForm
        visible={showForm}
        closeHandler={() => {
          setFormVisibility(false);
          setCurrentBranch(null);
        }}
        data={currentBranch}
        refreshList={() => fetchBranches({ page: currentPageNumber })}
      />
      <DeleteAlert
        title={currentBranch?.name}
        detail={""}
        visible={deleteVisible}
        setVisible={setDeleteVisibility}
        deleteText="branch"
        deleteWarning="This branch will be deleted permanently"
        handleDelete={handleDelete}
      />
      <div className="header__wrapper">
        <div className="header__left">
          <SearchInput
            placeholder={"Search any branch"}
            onChange={handleSearch}
          />
        </div>
        {user?.roleName === 'admin' && <div className="header__right">
          <ButtonComponent
            buttonContent="Add Branch"
            type="primary"
            iconLeft={<PlusOutlined />}
            onClick={() => {
              setCurrentBranch(null);
              setFormVisibility(true);
            }}
          />
        </div>}
      </div>

      <Table
        pagination={false}
        loading={loading}
        onRow={(record) => {
          return {
            onClick: (event) => setCurrentBranch(record),
          };
        }}
        className="institute__table"
        columns={[
          {
            title: "Branch",
            dataIndex: "name",
            key: "name",
            render: (text, record, index) => (
              <p className="institute-branch__name">
                {record?.logoUrl && (
                  <span>
                    <img src={record?.logoUrl} />{" "}
                  </span>
                )}

                {text}
              </p>
            ),
          },
          {
            title: "Branch ID",
            dataIndex: "id",
            key: "id",
          },
          {
            title: "Board",
            dataIndex: "board",
            key: "board",
            render: (text) => <p>{text?.acronym}</p>,
          },
          {
            title: "Contact Person",
            dataIndex: "contactPerson",
            key: "contactPerson",
          },
          {
            title: "Phone Number",
            dataIndex: "phoneNumber",
            key: "phoneNumber",
          },
          {
            title: "Email ID",
            dataIndex: "email",
            key: "email",
          },
          user?.roleName === 'admin' ?
            {
              dataIndex: "isActive",
              key: "isActive",
              render: (text, record) => (
                <Space size="large" className="float-right">
                  <ToggleSwitch
                    checked={text}
                    handleChange={(value) => handleToggle(record?.id, value)}
                  />
                  <CardMenu
                    menuText="Branch"
                    handleEdit={() => setFormVisibility(true)}
                    handleDelete={() => setDeleteVisibility(true)}
                  />
                </Space>
              ),
            }
            : {},
        ]}
        dataSource={branches}
        expandable={{
          expandIcon: ({ expanded, onExpand, record }) =>
            expanded ? (
              <DownOutlined
                className="expandable__icon"
                onClick={(e) => onExpand(record, e)}
              />
            ) : (
              <RightOutlined
                className="expandable__icon"
                onClick={(e) => onExpand(record, e)}
              />
            ),

          expandedRowRender: (record) => (
            <div className="expandable__wrapper">
              <div className="address__wrapper">
                <p className="address__title">Address</p>
                <p>{record?.registeredAddress}</p>
              </div>
              <div className="classes__wrapper">
                <p className="classes__title">Configured Classes</p>
                <p className="classes__name">
                  {record.classRooms?.map((value, index) => {
                    return (
                      <Space>
                        <p>{value?.name}</p>
                        <p className="id">(ID: {value?.branchClassRoomId})</p>
                        <p>
                          {index !==
                            (record?.classRooms?.length &&
                              record?.classRooms?.length - 1)
                            ? ", "
                            : ""}&nbsp;
                        </p>
                      </Space>
                    );
                  })}
                </p>
              </div>
            </div>
          ),
        }}
      />
      <PaginationComponent
        handlePageChange={handlePageChange}
        paginationMeta={paginationMeta}
      />
    </div>
  );
};
